import React, { useState, useEffect } from "react";
import axios from "../../utils/fvAxios";
import { TextField, TextareaAutosize, Typography, Button, Box, Stack } from "@mui/material";
import Security from "./Security";
import "./Myaccount.css";
import Divider from "@mui/material/Divider";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import { getOrgType } from "../../utils/Token";
import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import Logo from "../../Media/Upload.jpeg";
import apiinfo from "../../utils/base-uri.json";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MaskedTextField from "../../components/MaskedTextField";
import { useGlobalComponent } from '../../pages/commom/GlobalComponentProvider';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// Function to detect the image format from the Base64 string
import { HasScreenPermissions, HasPermissions } from '../../utils/Token';
import INFO from "../../utils/Enums.json";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CloseIcon from '@mui/icons-material/Close';


const getImageFormat = (fileName) => {
  if (fileName.endsWith("jpeg")) {
    return "jpeg";
  } else if (fileName.endsWith("png")) {
    return "png";
  } else if (fileName.endsWith("gif")) {
    return "gif";
  }
  console.error("NO IMAGE DATA FOUND");
  return "png";
};

export default function Personalinfo() {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      setSelectedImage(file);
      setSelectedImagePath(file.preview);
      console.log(file);
    };
    reader.readAsDataURL(file);
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpeg', '.png']
    }
  });
  const { currentActiveTab, currentActiveSubTab } = useGlobalComponent();
  const location = useLocation();


  useEffect(() => {
    if (location.pathname === "/ChangePassword") {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [location, currentActiveTab]);


  const style = useMemo(
    () => ({
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const thumbs = files.map((file) => <div key={file.name}>{file.name}</div>);
  // clean up
  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.name));
    },
    [files]
  );

  const [error, setError] = useState("");
  const [details, setDetails] = useState([]);
  const [FirstnameErr, setFirstnameErr] = useState("");
  const [LastNameErr, setLastNameErr] = useState("");
  const [TitleErr, setTitleErr] = useState("");
  const [EmailErr, setEmailErr] = useState("");
  const [PhoneNumberErr, setPhoneNumberErr] = useState(null);
  const [PhoneNumberExtErr, setPhoneNumberExtErr] = useState(null);
  const [MobileNumberErr, setMobileNumberErr] = useState(null);
  const [pricipal, setpricipal] = useState('');
  const [pricipalErr, setpricipalErr] = useState('');


  const [Firstname, setFirstname] = useState("");
  const [LastName, setLastName] = useState("");
  const [Title, setTitle] = useState("");
  const [Email, setEmail] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [MobileNumber, setMobileNumber] = useState("");
  const [AddDiscription, setAddDiscription] = useState("");
  const [PhoneNumberExt, setPhoneNumberExt] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImagePath, setSelectedImagePath] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [Trg, setTrg] = useState(false);
  const [SiteRepresentatives, setSiteRepresentatives] = useState([]);

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };




  useEffect(() => {
    axios
      .get(apiinfo.myAccounts.getAccounts)
      .then((res) => {
        if (res?.data?.data?.profileImageBlob) {
          const imageFormat = getImageFormat(res?.data?.data?.profileImageName);
          setSelectedImagePath(
            `data:image/${imageFormat};base64,${res?.data?.data?.profileImageBlob}`
          );
        }
        if (getOrgType() == "Client") {
          axios
            .get("MyAccount/GetSiteRepresentatives?userId=" + res?.data?.data?.userId)
            .then((res) => {
              setSiteRepresentatives(res?.data?.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        setDetails(res?.data?.data);
        setFirstname(res?.data?.data?.firstName);
        setLastName(res?.data?.data?.lastName);
        setTitle(res?.data?.data?.contactTitle);
        setEmail(res?.data?.data?.email);
        setPhoneNumberExt(res?.data?.data?.extNumber);
        setPhoneNumber(res?.data?.data?.phoneNumber);
        setMobileNumber(res?.data?.data?.mobileNumber == null ? "" : res?.data?.data?.mobileNumber);
        setAddDiscription(res?.data?.data?.additionalDescription);
        setpricipal(res?.data?.data?.principalCompanyOfficerName)
      })
      .catch((err) => {
        console.log(err);
      });
  }, [Trg]);

  const [UnitsList, setUnitsList] = useState([]);
  const [SitesList, setSitesList] = useState([]);
  const [UnitId, setUnitId] = useState("");
  const [SiteId, setSiteId] = useState("");
  const [OldUnitId, setOldUnitId] = useState("");
  const [OldSiteId, setOldSiteId] = useState("");
  const [ClientId, setClientId] = useState("");
  const [SafetyRepresentativeDialog, setSafetyRepresentativeDialog] = useState(false);
  const [IsDis, setIsDis] = useState(false);


  const SafetyRepresentativeDialogOpen = (e) => {
    setSafetyRepresentativeDialog(true);
    if (getOrgType() == "Client") {
      axios.get("Prequalification/GetPqClientBusinessUnits?clientId=" + e?.clientId)
        .then((res) => {
          setUnitsList(res?.data?.data);
        })
        .catch((err) => {
          console.log(err);
        });
      setClientId(e?.clientId);
      ChangeUnits(e?.clientBusinessUnitId);
      setSiteId(e?.clientBUSiteID);
      setOldUnitId(e?.clientBusinessUnitId);
      setOldSiteId(e?.clientBUSiteID);
    }

  };
  const SafetyRepresentativeDialogClose = () => {
    setSafetyRepresentativeDialog(false);
    setUnitId("");
    setSiteId("");
    setOldUnitId("");
    setOldSiteId("");
  };
  const SaveSafetyRepresentative = () => {
    setIsDis(true);
    const data = {
      "userId": details?.userId,
      "unitId": OldUnitId,
      "clientId": ClientId,
      "currentSiteId": SiteId,
      "oldSiteId": OldSiteId,
      "selectedBusUnitId": UnitId
    }
    axios.post("MyAccount/UpdateSiteSafetyRepresentative", data)
      .then(res => {
        if (res?.data?.responseCode == 100) {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsDis(false);
          SafetyRepresentativeDialogClose();
          setTrg(!Trg);
        }
        else {
          if (res?.data?.responseMessage == "Site Exists") {
            toast.error("Selected site already exists for this representative.Please select another one.", {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
          setIsDis(false);
        }
      }).catch(err => {
        console.log(err)
      })
  }

  const ChangeUnits = (e) => {
    setUnitId(e);
    axios
      .get("Prequalification/GetClientBusinessUnitSites?buId=" + e)
      .then((resp) => {
        setSitesList(resp?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const RemoveSafetyRepresentative = (val) => {
    axios
      .post("MyAccount/DeleteSiteRepresentative?siteId=" + val)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTrg(!Trg);
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }

  const ChangeFistName = (e) => {
    if (e == "") {
      setFirstname(e);
      setFirstnameErr("Please Enter Field");
    } else {
      setFirstname(e);
      setFirstnameErr("");
    }
  };
  const ChangeLastName = (e) => {
    if (e == "") {
      setLastName("");
      setLastNameErr("Please Enter Field");
    } else {
      setLastName(e);
      setLastNameErr("");
    }
  };
  const ChangeTitle = (e) => {
    if (e == "") {
      setTitle(e);
      setTitleErr("Please Enter Field");
    } else {
      setTitle(e);
      setTitleErr("");
    }
  };
  const ChangeEmail = (e) => {
    let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,20})[ ]*$/i;
    if (e == "") {
      setEmail(e);
      setEmailErr("Please Enter Field");
    } else if (!regEmail.test(e)) {
      setEmail(e);
      setEmailErr("Please check email format");
    } else {
      setEmail(e);
      setEmailErr("");
    }
  };
  const ChangePrincipal = (e) => {
    if (e == "") {
      setpricipal(e);
      setpricipalErr("Please Enter Field");
    } else {
      setpricipal(e);
      setpricipalErr("");
    }
  };
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '');
    if (numericInput.length <= 10) {
      if (numericInput === '') {
        // Field is empty, no error
        setPhoneNumber('');
        setPhoneNumberErr(true);
      } else if (/^\d{10}$/.test(numericInput)) {
        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
        setPhoneNumber(formattedInput);
        setPhoneNumberErr(false);
      } else {
        setPhoneNumber(numericInput);
        setPhoneNumberErr(true);
      }
    } else {
      // Limit to 10 digits, no further input allowed
      setPhoneNumber(numericInput);  //numericInput.slice(0, 9)
      setPhoneNumberErr(true);
    }
  };

  const MobileChange = (event) => {
    const inputValue = event.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '');
    if (numericInput.length <= 10) {
      if (numericInput === '') {
        // Field is empty, no error
        setMobileNumber('');
        setMobileNumberErr(false);
      } else if (/^\d{10}$/.test(numericInput)) {
        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
        setMobileNumber(formattedInput);
        setMobileNumberErr(false);
      } else {
        setMobileNumber(numericInput);
        setMobileNumberErr(true);
      }
    } else {
      // Limit to 10 digits, no further input allowed
      setMobileNumber(numericInput); //numericInput.slice(0, 9)
      setMobileNumberErr(true);
    }
  };


  const ChangeAdditional = (e) => {
    setAddDiscription(e);
  };

  const onSubmit = () => {
    setIsLoading(true);
    if (
      Firstname != "" &&
      LastName != "" &&
      Title != "" &&
      Email != "" &&
      PhoneNumber != "" &&
      FirstnameErr == "" &&
      LastNameErr == "" &&
      TitleErr == "" &&
      EmailErr == ""
    ) {
      // const Data = {
      //   userId: details?.userId,
      //   firstName: Firstname,
      //   lastName: LastName,
      //   contactTitle: Title,
      //   phoneNumber: PhoneNumber,
      //   mobileNumber: MobileNumber,
      //   additionalDescription: AddDiscription,
      //   email: Email,
      //   principalCompanyOfficerName: details?.principalCompanyOfficerName,
      //   extNumber: "",
      //   ProfileImage: selectedImage
      // };
      const formData = new FormData();
      formData.append("userId", details?.userId);
      formData.append("firstName", Firstname);
      formData.append("lastName", LastName);
      formData.append("contactTitle", Title);
      formData.append("phoneNumber", PhoneNumber);
      formData.append("mobileNumber", MobileNumber);
      formData.append("additionalDescription", AddDiscription);
      formData.append("email", Email);
      formData.append(
        "principalCompanyOfficerName",
        pricipal
      );
      formData.append("extNumber", PhoneNumberExt ? PhoneNumberExt : "");


      if (selectedImage != null) {
        formData.append("ProfileImage", selectedImage);
        if (details?.profileImageName != null && details?.profileImageId != null) {
          formData.append("ProfileImageName", details?.profileImageName);
          formData.append("ProfileImageId", details?.profileImageId);
        }
      }


      axios
        .post(apiinfo.myAccounts.saveAccount, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res?.data?.status == true) {
            toast.success(res.data.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setTrg(!Trg);
          } else {
            toast.error(res.data.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        }).finally(() => {
          setIsLoading(false);
        })
    } else {
      // if (MobileNumberErr != "") {
      //   toast.error("Please check MobileNumber format", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      //   });
      // } else {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsLoading(false);
    }
    // }
  };





  return (
    <React.Fragment>

      <ToastContainer />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="form" style={{ overflowX: "hidden" }}>
        <label className="personal-info-heading">
          <b>{t("Myinformation.personal")}</b>
        </label>
        <div className="personal-info-subheading">
          <span>
            {t("Myinformation.lastlogin")}:{" "}
            {/* {GetfVDateFormate("", details.lastLoginDate)} */}
            {details.lastLoginDate ? GetfVDateFormate("", details.lastLoginDate) : "No Changes"}
          </span>
        </div>
        <Divider className="mt-3" />
        <div className="row">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Myinformation.selectphoto")}
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1 " style={{ width: "350px" }}>
            <div className="drop p-1" {...getRootProps({ style })}>
              <input {...getInputProps()} />

              {selectedImage || selectedImagePath ? (
                // <img height={100} width={100} src={`data:image/${imageFormat};base64,${selectedImagePath}`} alt="Uploaded" />
                <img
                  height={100}
                  width={100}
                  src={selectedImagePath ?? selectedImage?.preview}
                  alt="Uploaded"
                />
              ) : (
                <>
                  <img className="mt-2" src={Logo} alt="" />
                  <br />
                  <span className="text-muted mt-2 fs">
                    <b>
                      <span className="mx-1 cl">
                        {t("DragandDrop.firstLabel1")}
                      </span>
                      {t("DragandDrop.firstLabel2")}
                    </b>
                  </span>
                  <br />
                  <span className=" text-muted Fs">
                    {t("DragandDrop.secondLabel")}
                  </span>
                </>
              )}

              <span className=" text-muted Fs"> {thumbs}</span>
            </div>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-4">
            <span className="input-label-right">
              {t("Myinformation.firstname")}{" "}
              <small style={{ color: "red" }}>*</small>
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                width: "320px"
              }}
              size="small"
              id="firstName"
              name="firstName"
              value={Firstname || ""}
              placeholder={t("Myinformation.firstname")}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => ChangeFistName(e.target.value)}
            />
            <p className="text-danger mx-2 mt-1" >
              {FirstnameErr}
            </p>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Myinformation.lastname")}{" "}
              <small style={{ color: "red" }}>*</small>
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                width: "320px"
              }}
              id="lastName"
              name="lastName"
              placeholder={t("Myinformation.lastname")}
              size="small"
              value={LastName || ""}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => ChangeLastName(e.target.value)}
            />
            <p className="text-danger mx-2 mt-1" component={"span"}>
              {LastNameErr}
            </p>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Myinformation.title")}{" "}
              <small style={{ color: "red" }}>*</small>
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                width: "320px"
              }}
              id="title"
              name="title"
              placeholder={t("Myinformation.title")}
              size="small"
              value={Title || ""}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => ChangeTitle(e.target.value)}
            />
            <p className="text-danger mx-2 mt-1" component={"span"}>
              {TitleErr}
            </p>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Myinformation.phonenumber")}{" "}
              <small style={{ color: "red" }}>*</small>
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 },
                width: "320px"
              }}
              value={PhoneNumber || ""}
              onInput={handleInputChange}
              size="small"
              placeholder={t("Myinformation.phonenumber")}
              id="outlined-name"
              variant="outlined"
              className="form-control text-feild-custom mx-2"
              error={PhoneNumberErr}
              helperText={PhoneNumberErr ? 'Invalid  format. Use (xxx) xxx-xxxx' : ''}
            />
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Myinformation.phonenumberextension")}
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 },
                width: "320px"
              }}
              required
              id="extNumber"
              name="extNumber"
              placeholder={t('Mycompany.phonenumberextension')}
              size='small'
              value={PhoneNumberExt || ""}
              onChange={(event) => {
                const inputValue = event.target.value;
                const numericInput = inputValue.replace(/[^0-9]/g, '');
                if (numericInput.length == 10) {
                  if (numericInput === '') {
                    // Field is empty, no error
                    setPhoneNumberExt('');
                    setPhoneNumberExtErr(false);
                  }
                  else if (numericInput) {
                    setPhoneNumberExt(numericInput);
                    setPhoneNumberExtErr(false);
                  } else {
                    setPhoneNumberExt(numericInput);
                    setPhoneNumberExtErr(true);
                  }
                } else if (numericInput.length < 10) {
                  if (numericInput === '') {
                    // Field is empty, no error
                    setPhoneNumberExt('');
                    setPhoneNumberExtErr(false);
                  } else {
                    setPhoneNumberExt(numericInput);
                    setPhoneNumberExtErr(true);
                  }
                } else {
                  // Limit to 10 digits, no further input allowed
                  // setPhone(numericInput.slice(0, 10));
                  setPhoneNumberExt(numericInput);
                  setPhoneNumberExtErr(true);
                }
              }}
              error={PhoneNumberExtErr}
              helperText={PhoneNumberExtErr ? 'Only numbers 0000000000' : ''}
              className="form-control text-feild-custom mx-2"
            />
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Myinformation.mobilenumber")}
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 },
                width: "320px"
              }}
              value={MobileNumber || ""}
              onInput={MobileChange}
              size="small"
              placeholder={t("Myinformation.mobilenumber")}
              id="outlined-name"
              variant="outlined"
              className="form-control text-feild-custom mx-2"
              error={MobileNumberErr}
              helperText={MobileNumberErr ? 'Invalid  format. Use (xxx) xxx-xxxx' : ''}
            />
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3 ">
            <span className="input-label-right">
              {" "}
              {t("Myinformation.email")}
              <small style={{ color: "red" }}>*</small>{" "}
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                width: "320px"
              }}
              id="email"
              name=""
              value={Email || ""}
              placeholder={t("Myinformation.email")}
              size="small"
              InputProps={{
                readOnly: true,
              }}
              //disabled={getOrgType() != "Admin"}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => ChangeEmail(e.target.value)}
            />
            <p className="text-danger mx-2 mt-1" component={"span"}>
              {EmailErr}
            </p>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {" "}
              {t("Myinformation.additional")}{" "}
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
            <TextareaAutosize
              minRows={3}
              style={{ width: "320px" }}
              id="additionalDescription"
              name="additionalDescription"
              placeholder={t("Myinformation.additional")}
              size="small"
              value={AddDiscription || ""}
              className="form-control text-feild-custom mx-2"
              onChange={(e) => ChangeAdditional(e.target.value)}
            />
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>


          <div className="row mt-2" >

            <h4 className="mx-2"></h4>
            <label className="personal-info-heading">
              <b>Company Access</b>
            </label>

            <br />
            <span className="mx-3" style={{ color: "black" }}>   {details?.vendorOrgName}</span>
            <div className="col-sm-6 col-md-6 col-xl-6 mt-3 " hidden={getOrgType() != "Vendor"}>
              <span className="input-label-right">

                {"Company Principal Officer Name:"}

              </span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-2" hidden={getOrgType() != "Vendor"}>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px"
                }}
                id="pricipal"
                name="pricipal"
                value={pricipal || ""}
                placeholder={"Company Principal Officer Name"}
                size="small"
                className="form-control text-feild-custom mx-2"
                onChange={(e) => ChangePrincipal(e.target.value)}
              />
              <p className="text-danger mx-2 mt-1" component={"span"}>
                {pricipalErr}
              </p>
            </div>
            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
          </div>
          <Divider className="mt-3" />
          <div className="row mt-3 mb-3">
            <div className="text-right">
              {HasPermissions(INFO?.Screens?.MyAccount, INFO?.ScreenPermissions?.Modify) && <Button
                variant="contained"
                color="primary"
                disabled={PhoneNumberErr || PhoneNumberExtErr || MobileNumberErr}
                sx={{ padding: "15px", textTransform: "capitalize" }}
                onClick={onSubmit}
              >
                {t("Myinformation.save")}
              </Button>
              }
            </div>

          </div>

        </div>
        <div className="mx-4 mt-3" hidden={getOrgType() != "Client"}>
          <Dialog
            open={SafetyRepresentativeDialog}
            keepMounted
            onClose={SafetyRepresentativeDialogClose}
            aria-describedby="alert-dialog-slide-description"
          >

            <div style={{ marginLeft: "auto" }}>
              <span className='mx-2' onClick={SafetyRepresentativeDialogClose} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
            </div>
            <DialogTitle> Client Units and Sites</DialogTitle>
            <DialogContent>
              <div className="mt-3">
                <span style={{ color: "#3E4A62" }}>
                  Business Unit<small style={{ color: "red" }}>*</small>
                </span>
                <br />

                <Select
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    width: "320px",
                  }}
                  labelId="demo-multiple-name-label"
                  value={UnitId || ""}
                  id="demo-multiple-name"
                  size="small"
                  onChange={(e) => ChangeUnits(e.target.value)}
                  MenuProps={MenuProps}
                >
                  {UnitsList?.map((item, index) => (
                    <MenuItem key={index} title={item.value} value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div>
                <span style={{ color: "#3E4A62" }}>Site <small style={{ color: "red" }}>*</small></span>
                <br />
                <Select
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    width: "320px",
                  }}
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  size="small"
                  value={SiteId || ""}
                  onChange={(e) => setSiteId(e.target.value)}
                  MenuProps={MenuProps}
                >
                  {SitesList?.map((item, index) => (
                    <MenuItem key={index} title={item.siteName} value={item.businessUnitSiteId}>
                      {item.siteName}
                    </MenuItem>
                  ))}
                </Select>
              </div>

            </DialogContent>
            <DialogActions>
              <div className="login-help__buttonContainer mt-4">
                <Button className="login-help-button-cancel mx-2" variant="contained" sx={{ padding: "15px", textTransform: "capitalize" }} onClick={SafetyRepresentativeDialogClose}>Cancel</Button>
                <Button className="login-button-request mx-2" disabled={IsDis} variant="contained" sx={{ padding: "15px", textTransform: "capitalize", float: "right" }} onClick={SaveSafetyRepresentative}>Save</Button>
              </div>
            </DialogActions>
          </Dialog>


          <span style={{ fontSize: "17px", fontWeight: "bold" }}>Safety Representative for the following Sites </span>
          {SiteRepresentatives?.length == 0
            ? <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" className="text-center p-1 mt-3" >
              <span >Not associative has a Safety Representative for any of the sites</span>
            </Box>
            : <Box className="mt-3" border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec">
              <TableContainer component={Paper} size="small">
                <Table sx={{ minWidth: 650, border: " 1px black" }} aria-label="simple table" size="small">
                  <TableBody>
                    {SiteRepresentatives?.map((r, i) => (
                      <TableRow
                        key={i}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          <p style={{ color: "blue", cursor: "pointer" }} onClick={() => SafetyRepresentativeDialogOpen(r)}>{r.businessUnitname}</p>
                        </TableCell>
                        <TableCell align="center"><p style={{ color: "blue", cursor: "pointer" }} onClick={() => SafetyRepresentativeDialogOpen(r)}>{r.siteName}</p></TableCell>
                        <TableCell align="right"> <span className='mx-2' onClick={() => RemoveSafetyRepresentative(r?.clientBUSiteID)} style={{ color: "red", cursor: "pointer" }}><CloseIcon /></span></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          }
        </div>
      </div>

      <div className="mt-3" hidden={HasPermissions(INFO?.ChangePassword?.actionName,"R")}>
        <Security date={details.lastPasswordChangedDate} />
      </div>

    </React.Fragment>
  );
}